import React, { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap';

export const CameraFeed = ({ sendFile }) => {
    const [isCameraLoading, setisCameraLoading] = useState(true);
    const [cameraLoadError, setcameraLoadError] = useState("");
    let player;

    useEffect(() => {
        stopCamera();
        initializeMedia();
    }, [])
    const initializeMedia = async () => {

        if (!("mediaDevices" in navigator)) {
            navigator.mediaDevices = {};
        }

        if (!("getUserMedia" in navigator.mediaDevices)) {
            navigator.mediaDevices.getUserMedia = function (constraints) {
                var getUserMedia =
                    navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia || navigator.msGetUserMedia;
                if (!getUserMedia) {
                    setisCameraLoading(false)
                    setcameraLoadError('Error : User media is not implemented on this browser.');
                    return Promise.reject(new Error("User media is not implemented on this browser."));
                }
                return new Promise((resolve, reject) => {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            };
        }

        const videoInputs = await getListOfVideoInputs();

        if (videoInputs.length) {
            navigator.mediaDevices
                .getUserMedia({
                    video: true
                })
                .then((stream) => {
                    player.srcObject = stream;
                    setisCameraLoading(false)
                })
                .catch((error) => {
                    setisCameraLoading(false);
                    if (error.toString().includes('Permission denied')) {
                        setcameraLoadError('Error : Camera permisson is blocked on this browser, please allow access to the camera.');
                    } else if (error.toString().includes('Failed to allocate videosource')) {
                        setcameraLoadError('Error : The camera is already in use in some browser or tab. Please check');
                    } else {
                        setcameraLoadError('Error : Camera cannot start on this device.please try to open link on different device.');
                    }
                    return Promise.reject(new Error("Camera cannot start on this device.please try to open link on different device."));
                });
        } else {
            setisCameraLoading(false);
            setcameraLoadError('Error : Camera is not working on this device. please try to open link on different device.');
            return Promise.reject(new Error("Camera is not working on this device. please try to open link on different device."));
        }
    };

    const capturePicture = () => {
        var canvas = document.createElement("canvas");
        canvas.width = player.videoWidth;
        canvas.height = player.videoHeight;
        var contex = canvas.getContext("2d");
        contex.drawImage(player, 0, 0, canvas.width, canvas.height);
        stopCamera();
        sendFile(canvas.toDataURL())
    };
    const stopCamera = () => {
        var videoEl = document.querySelector('video');
        let stream = videoEl.srcObject;
        let tracks = stream ? stream.getTracks() : "";
        if (tracks && tracks.length > 0){
            tracks.forEach(function (track) {
                track.stop();
            });
        }
        videoEl.srcObject = null;
    }
    const getListOfVideoInputs = async () => {
        const enumerateDevices = await navigator.mediaDevices.enumerateDevices();
        return enumerateDevices.filter((device) => device.kind === "videoinput");
    };

    // switchCamera = async () => {
    //     const listOfVideoInputs = await getListOfVideoInputs();
    //     if (listOfVideoInputs.length > 1) {
    //         if (player.srcObject) {
    //             player.srcObject.getVideoTracks().forEach((track) => {
    //                 track.stop();
    //             });
    //         }

    //         if (cameraNumber === 0) {
    //             cameraNumber = 1;
    //         }
    //         else if (cameraNumber === 1) {
    //             cameraNumber = 0;
    //         }
    //         initializeMedia();
    //     } else if (listOfVideoInputs.length === 1) {
    //         alert("The device has only one camera");
    //     } else {
    //         alert("The device does not have a camera");
    //     }
    // };




    return (
        <div className="App">
            {isCameraLoading && (
                <Alert key={1} variant={'info'}>
                    Please wait, camera is loading..
                </Alert>
            )}
            {cameraLoadError && (
                <Alert key={1} variant={'danger'}>
                    {cameraLoadError}
                </Alert>
            )}
            <video
                ref={(refrence) => {
                    player = refrence;
                }}
                autoPlay
            ></video>
            <button className='btn btn-blue' onClick={capturePicture} disabled={cameraLoadError}>Capture</button>
        </div>
    )
}
